/**
 * UGCSection — pitch the "paste-zh=en-pairs, get-a-playable-course" editor.
 */
import { GlassButton } from '@/components/GlassButton';
import { Icon, type IconName } from '@/components/Icon';
import { Reveal } from '@/components/Reveal';

const SAMPLE_TEXT = `Take it easy. = 放松点。
Could you do me a favor? = 能帮我个忙吗？
I have no idea what you mean. = 我完全不明白。`;

const MODE_CHIPS: Array<{ icon: IconName; label: string }> = [
  { icon: 'puzzle',   label: 'PUZZLE' },
  { icon: 'typing',   label: 'TYPING' },
  { icon: 'speaking', label: 'SPEAKING' },
];

export function HomeUGC(): JSX.Element {
  return (
    <section className="relative py-24 md:py-32 border-t border-honey-400/10">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid gap-12 md:grid-cols-2 items-center">
        <Reveal>
          <UGCMock />
        </Reveal>
        <Reveal delay={0.1}>
          <div>
            <div className="inline-flex items-center gap-2 text-xs font-arcade tracking-[0.2em] text-ember-300 mb-4">
              <span className="h-px w-6 bg-ember-400/60" />
              UGC EDITOR · 自己造课
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-balance text-white">
              市面上的题库都不喜欢？ <span className="text-gradient-warm">自己造一节</span>
            </h2>
            <p className="mt-5 text-lg text-cream-300/90 leading-relaxed">
              美剧台词、邮件原文、喜欢的歌词、老师讲过的语法例句 —
              <span className="text-honey-300"> 粘贴进去 5 秒就生成一节课</span>。
              立刻能用拼图、打字、口语三种模式反复练。
            </p>
            <div className="mt-6">
              <GlassButton to="/app/create" size="lg" variant="solid">
                试试编辑器 →
              </GlassButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

function UGCMock(): JSX.Element {
  return (
    <div className="glass-card rounded-3xl p-5">
      <div className="text-xs uppercase tracking-[0.2em] font-arcade text-honey-300 mb-3">
        PASTE · ANY zh = en
      </div>
      <pre className="font-mono text-xs text-cream-200 bg-ink-950 border border-honey-400/20 rounded-2xl p-4 leading-relaxed whitespace-pre-wrap">
        {SAMPLE_TEXT}
      </pre>
      <div className="mt-3 flex items-center justify-between text-xs">
        <div className="font-arcade text-mint-300 tracking-widest">→ 3 条解析成功</div>
        <div className="font-arcade text-ember-300 tracking-widest">→ COURSE READY</div>
      </div>
      <div className="mt-3 grid grid-cols-3 gap-2">
        {MODE_CHIPS.map((m) => (
          <div key={m.label} className="rounded-xl bg-ink-800/60 border border-honey-400/30 px-2 py-2 text-center text-xs font-arcade text-honey-300 inline-flex items-center justify-center gap-1.5">
            <Icon name={m.icon} size="sm" />
            {m.label}
          </div>
        ))}
      </div>
    </div>
  );
}
